<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="container-fluid spacer-top-navigation">
  @if (isAdult$ | async) {
    <div class="container">
      @if (showSituationAndChecklist() && (depotFacade.underageOnboardingEnabled$ | async)) {
        <a class="mb-3 d-flex align-items-center gap-small" (click)="showSituationAndChecklist.set(false)">
          <web-design-system-icon name="chevron-3" color="action" />
          <span class="zero-text link p-base-med">{{ 'back-link' | transloco }}</span>
        </a>
        <child-onboarding-situation-checklist [situations]="store.situations()" (startOnboarding)="start($event)" />
      } @else {
        <web-components-user-notes target="childdepot" />
        <child-onboarding-onboardings-list
          [childOnboardings]="store.childOnboardingEntities()"
          [underageOnboardingEnabled]="depotFacade.underageOnboardingEnabled$ | async"
          (addOnboarding)="add()"
          (continueOnboarding)="continue($event)"
          (confirmOnboarding)="confirm($event)"
          (deleteOnboarding)="delete($event)"
        />
      }
      @if ((depotFacade.underageOnboardingEnabled$ | async) === false) {
        <web-design-system-notification color="red" size="mid" class="text-center">
          {{ 'child-onboarding.home.onboarding-disabled' | transloco }}
        </web-design-system-notification>
      }
    </div>
  }
</div>
